import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const defaultEndDate = () => {
  return moment().subtract(1, "months").endOf("month").format();
};

const endDateSlice = createSlice({
  name: "endDate",
  initialState: defaultEndDate(),
  reducers: {
    setEndDate(state, action) {
      return action.payload;
    },
  },
});

export const { setEndDate } = endDateSlice.actions;
export default endDateSlice.reducer;
